// NavbarData.tsx
export interface DropdownItem {
    id: string;
    label: string;
    to: string;
     href?: string;
    isExternal?: boolean;
    isHighlighted?: boolean;
    children?:{
        id: string;
        label: string;
        to: string;
         href?: string;
    }[]
}

export interface DropdownSection {
    title?: string;
    items: DropdownItem[];
}

export interface NavDropdownData {
    [key: string]: DropdownSection[];
}

export interface NavItem {
    id: string;
    label: string;
    to: string;
    href?: string;
    children?:{
        id: string;
        label: string;
        to: string;
         href?: string;
    }[]
}

export const navDropdownData: NavDropdownData = {
    'about': [
        {
            items: [
                { id: 'guiding-principles', label: 'Guiding Principles', to: '',href:'https://aosmithcorporation.sharepoint.com/SitePages/Guiding-Principles.aspx' },
                { id: 'values', label: 'Values', to: '',href:'https://aosmithcorporation.sharepoint.com/SitePages/Statement-of-Values.aspx?web=1' },
                // { id: 'smith-way', label: 'The Smith Way', to: '' },
                // { id: 'historyAO Smith India Journey', label: 'AO Smith India Journey', to: '/about' },
            ]
        },
        {
            title: 'Countries',
            items: [
                { id: 'bangladesh', label: 'Bangladesh (BGD)', to: '/about?country=bangladesh',children:[{
                    id:'idmumbai',
                    to:'/about?country=bangladesh',
                    label:'AO Smith Bangladesh Journey'

                }]  },
                { id: 'india', label: 'India (IND)', to: '/about?country=india' ,children:[{
                    id:'idmumai',
                    to:'/about?country=india',
                    label:'AO Smith India Journey'

                }] },
                { id: 'srilanka', label: 'Sri Lanka (LKA)', to: '/about?country=sri-lanka',children:[{
                    id:'idmumai',
                    to:'/about?country=sri-lanka',
                    label:'AO Smith Sri Lanka Journey'

                }]  },
            ]
        },
        {
            items: [
                // { id: 'leadership', label: 'Leadership', to: '/about/leadership' },
                { id: 'brands', label: 'Brands', to: '/brands' },
                // { id: 'ao-smith', label: 'A. O. Smith', to: '/brands#ao-smith' },
                // { id: 'pureit', label: 'Pureit', to: '/brands#pureit' },
                { id: 'products', label: 'Products', to: '/products' },
                // { id: 'ao-smith-global', label: 'AO Smith Global', to: '/products/ao-smith-global', isHighlighted: true },
            ]
        }
    ],
    'events': [
        {
            items: [
                { id: 'birthdays', label: 'Birthdays', to: '/birthday-list' },
                { id: 'engagement', label: 'Engagement', to: '/engagement' },
                { id: 'news', label: 'News', to: '/news-events' },
                { id: 'work-anniversaries', label: 'Work anniversaries', to: '/anniversary-list' },
            ]
        }
    ],
    'ethics-compliance': [
        {
            items: [
                { id: 'speakup-line', label: 'Speakup Line', to: '', isHighlighted: true,href:'https://aosmithcorporation.sharepoint.com/SitePages/Ethics.aspx',isExternal:true },
                // { id: 'smith-way', label: 'The Smith Way', to: '/', isHighlighted: true },
                { id: 'toolkits', label: 'Toolkits', to: '', isHighlighted: true ,href:'https://aosmithcorporation.sharepoint.com/SitePages/ToolKits.aspx?source=https%3a//aosmithcorporation.sharepoint.com/SitePages/Forms/RecentChanges.aspx',isExternal:true},
            ]
        }
    ],
    'contact': [
        {
            items: [
                { id: 'bangalore', label: 'Bangalore - IND', to: '/contact?location=bangalore'},
                { id: 'colombo', label: 'Colombo - LKA', to: '/contact?location=colombo' },
                { id: 'dhaka', label: 'Dhaka - BGD', to: '/contact?location=dhaka' },
                { id: 'mumbai', label: 'Mumbai - IND', to: '/contact?location=mumbai' },
            ]
        }
    ],
    'training': [
        {
            items: [
                { id: 'ai-hub', label: 'AI Hub', to: '', isExternal: true, href: 'https://aosmithcorporation.sharepoint.com/sites/AIHub' },
                { id: 'learning-centre', label: 'Learning Centre', to: '', isExternal: true, href: 'https://aosmith.in/portalvideo/story.html' },
                { id: 'videos', label: 'Videos', to: '/videos' },
            ]
        }
    ]
};